import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/news-card/news-card.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/news-tag-section/news-tag-section.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/news/featured-story-hero/featured-story-hero.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/news/page.module.css");
